import apiUrl from '../../../constants';
import awsBucketName from '../../../constants';
import axios from 'axios';
import CryptoJS from 'crypto-js';
import {
  Validator
} from 'vee-validate'
import VueElementLoading from 'vue-element-loading';
import {
  BasicSelect
} from 'vue-search-select'
import Paginate from 'vuejs-paginate'
import moment from 'moment'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css';
import { createRECManifest } from '../../../services/createRECManifest';
import UserIPTracking from '../../../interface/userTracker';
import { sendIPTrackingData } from '../../../services/userIPTrack';
import { STDStatusList,STDBagconditionList } from '../../../services/STDBagConditionList';
import { changeBucketOwner, externalDisputeAction, uploadDisputeFiles, fetchClientImages, disputeSubReason, fetchExternalDisputeReasons, externalDisputeActions,getImage,getVideoUrl } from '../../../services/externalDispute';
import { isValidUrl } from '../../../services/utility';
import { createShipmentSummaryAccess } from '../../../common/shipmentSummaryAccess';

export default {
  name: 'editinvestigationActionByoperation',
  components: {
    Multiselect
  },
  data() {
    return {
      // pop-up data

      imagesarr: [],
      attachment: null,
      displaytable: false,
      description: '',
      image: '',
      imgData:'',
      currenthubnamepop: '',
      username: '',
      takeaction: '',
      verifiedas: '',
      showupload: true,
      statuss: '',
      // try
      path: `${awsBucketName}/1234/wallpaperflare.com_wallpaper-1.jpg`,
      //   fname1: 'download.jpeg',
      fname1: 'wallpaperflare.com_wallpaper-1.jpg',
      imgdata: '',
      vStatusList:[],
      showModal: false,
      StatusList:[],
      awbnumber: '',
      ids: '',
      takeactionlist: [],
      takeActionname: '',
      takeactionId: '',
      bagCondition:'',
      bagConditionList:[],
      STDreason:'',
      lostReason:'',
      STDreasonList:[],
      actionName: '',
      takeActionloader: false,
      takeaction: false,
      FileSelected: null,
      istakeaction: false,
      declaredvalues: '',
      subReasonList:[],
      showBagCondition:false,
      blockVerifiedAsFlag: false,
      showLostReasonFlag:false,
      newBucket: '',
      bucketList: [],
      bucketChangeComment: '',
      reason: '',
      images: [],
      isDispute: false,
      Isvideo: false,
      assetsClient: [],
      disputeReasonList: [],
      disputeReason: '',
      isAcceptanceDispute: true,
      externalDisputeActionsMap : {},
      verifiedAs: [],
      previousshipmentstatus:'',
      clientImages:[],
      assetsClientValue:'',
      userFirstLastName : '',
      shipmentType: ''
    };
  },
  mounted() {
    var userToken = window.localStorage.getItem('accessuserToken');
    this.myStr = userToken.replace(/"/g, '');
    this.username = window.localStorage.getItem('username');
    this.statuss = this.$route.query.status;
    this.awbnumber = this.$route.query.awb;
    this.previousshipmentstatus = this.$route.query.previousshipmentstatus ? this.$route.query.previousshipmentstatus:" ";
    this.isDispute = ([20].includes(parseInt(this.statuss))) ? true : false;
    this.takeAction()
    this.verifiedAsOptions();
    this.lostReasons();
    this.getImages();
    this.currenthubidPop = this.$route.query.currenthubname.toString();
    this.previousshipmentstatus = this.$route.query.previousshipmentstatus ? this.$route.query.previousshipmentstatus:" ";
    // this.declaredvalues = this.$route.query.declaredvalue.toString();
    this.declaredvalues = this.$route.query.declaredvalue?this.$route.query.declaredvalue:' '
    this.shipmentType = this.$route.query.previousshipmentstatus ? this.$route.query.previousshipmentstatus.split(' ')[0] : '';
    this.ids = this.$route.query.id;
    setTimeout(()=>{
      document.documentElement.scrollTop = 0;
      },500);

  },
  computed: {
    normalizedVideos() {
      if (!this.assetsClient ||!this.assetsClient.length) return [];
      return this.assetsClient.map(item => {
        const videoObj =item.vediourl &&item.vediourl.length > 0? item.vediourl[0]: {};
        const videos = [];
        for (const key in videoObj) {
          const url = videoObj[key];
          if (url && typeof url === 'string' && url.trim() !== '') {
            videos.push({key,url,label: this.getVideoLabel(key)});
          }
        }
        return Object.assign({}, item, { videos: videos });
      });
    }
  },
  methods: {
    takeAction() {
      this.takeActionloader = true
      this.takeActionname = ''
      this.input = ({
        investigateshipmentstatusmasterid: this.statuss,
        investigationbuckettypeid: 1,
      });
      axios({
        method: 'post',
        url: `${apiUrl.api_url}TakeAction`,
        data: this.input,
        headers: {
          Authorization: `Bearer ${this.myStr}`,
        },
      }).then((result) => {
        this.takeActionloader = false
        var takeactiondata = [];
        let externalDisputeActionsMap = externalDisputeActions()
        result.data.data.forEach((x) => {
          takeactiondata.push({
            id: x.investigationactionmasterid,
            label: externalDisputeActionsMap[x.investigationactionmasterid] ? externalDisputeActionsMap[x.investigationactionmasterid] : x.actionname,
          });
        });
        if(this.statuss == 18){
          if(this.previousshipmentstatus.toLowerCase() == 'pickupdone'){
          let index = takeactiondata.findIndex(x => x.id === 27);
          takeactiondata.splice(index,1);
        }
        else{
            let index = takeactiondata.findIndex(x => x.id === 37);
            takeactiondata.splice(index,1);
        }
      }
        this.takeactionlist = takeactiondata;
        if (takeactiondata.length == 0) {
          this.istakeaction = true;
        }
      },
        (error) => {
          console.error(error);
        });

    },
    onImageFileChange(event,folder) {
      let multipleFiles = [...event.target.files];
        multipleFiles.forEach((file) => {
          
          this.attachment = file;
          let fileType = file.type.split('/')[0];
          if(fileType.toLowerCase() === 'image' && file.size > 2000000) {
            this.$alertify.error("Image should not be greater than 2 MB") 
            return;
          }
          if(fileType.toLowerCase() === 'video' && file.size > 10000000) {
            this.$alertify.error("Video should not be greater than 10 MB") 
            return;
          }
          const fr = new FileReader();
            fr.onload = () => {
              if(this.images.length == 4 && fileType.toLowerCase() === 'image'){
                this.$alertify.error("max 4 images are allowed.") 
                return;
              }
              if(this.images.length == 1 && fileType.toLowerCase() === 'video'){
                this.$alertify.error("max 1 vide is allowed.") 
                return;
              }
              this.images.push({attachment : file, url: fr.result});
            };
            fr.readAsDataURL(file);
                
          this.FileSelected = this.attachment;
          this.FileSelected = null;
        });
    },

    verifiedAsOptions(){
      this.verifiedAs = [{text: 'Photographically', value: 'Photographically'}];
      if(this.statuss == 20) this.verifiedAs.push({text: 'Video / Footage', value: 'Video'});
      else this.verifiedAs.push( {text: 'Physically',value: 'Physically'} );      
    },

    fetchDisputeReasons(actionId){
      let input = {
        disputeRaisedType : "XB"
      }
      if(this.shipmentType) input.taskType = this.shipmentType;
      if(actionId == 29) input.serviceType = "accept";
      if(actionId == 33) input.serviceType = "reject";
      fetchExternalDisputeReasons(input, this.myStr).then(reasons => {
        let resonData = reasons.data.ReturnResult;
        this.disputeReasonList = resonData.map((reasons, i) => ({id: i, label: reasons.reason}));
      })
    },

    removeImage(imageIndex){
      if (imageIndex > -1) {
          this.images.splice(imageIndex, 1);
      }
    },

    uploadDisputeFiles(){
      this.images.forEach(img => {
        let retry = 0;
        let form = new FormData();
            form.append('file', img.attachment);
            form.append('shippingid', this.awbnumber);

        uploadDisputeFiles(form, this.myStr).then(res => {
          if(!res.status && retry < 5) {
            uploadDisputeFiles(form, this.myStr);
            retry++
          }
        }).catch();
      });
    },
    lostReasons() {
      axios({
        method: 'post',
        url: `${apiUrl.api_url}rtoDisputeSubStatus`,
        data: {},
        headers: {
          Authorization: `Bearer ${this.myStr}`,
        },
      }).then((result) => {
        const substatusdata = [];
        result.data.data.forEach((sub) => {
          substatusdata.push({
            id: sub.pickupstatuscode,
            label: sub.pickupstatusname,
          });
        });
        this.subReasonList = substatusdata;
      },
        (error) => {
          console.error(error);
        });
    },
    resetForm() {

      if (this.imagesarr.length != []) {
        this.$alertify.error("Please Delete image")

      } this.$validator.reset(); this.errors.clear();
    },

    Backinvestigation() {
      if (this.imagesarr.length != []) {
        this.$alertify.error("Please Delete image")

      }
      else {
        this.$router.push({ path: '/InvestigationActionByOperations' });
      }

    },
    selectData(actionId, actionName) {
      if(this.statuss == 20){
        this.fetchDisputeReasons(actionId);
        this.isAcceptanceDispute = true;
        if(actionId == 33) this.isAcceptanceDispute = false;
      }
      this.takeactionId = actionId;
      this.actionName = actionName;
      this.blockVerifiedAsFlag = false;
      this.showLostReasonFlag = false;
      this.showupload = true;
      if(this.takeactionId == 13){
        this.blockVerifiedAsFlag = true;
        this.showupload = false;
      }
      if(this.takeactionId=="14" || this.takeactionId=="4"){
        this.showBagCondition=true
        this.bagConditionList=STDBagconditionList()
        this.STDreasonList=STDStatusList()
      }
      if(this.takeactionId == 36){
        this.lostReasons()
        this.showLostReasonFlag = true;
      }
      else{
          this.showBagCondition=false
      }

    },
    selectData1(event) {
      this.verifiedas = event;

    },
    updateExternalDispute(){
      if(this.description.length < 20){
        this.$alertify.error("Description should be greater than 20 character");
        return;
      }
      if (!this.verifiedas) {
        this.$alertify.error("Please Select Verified As.")
      }
      else{
      let input = {
        ShippingID : this.awbnumber,
        username : window.localStorage.getItem('username'),
        actionstatuscode : this.takeactionId.toString(),
        reason:this.disputeReason.label.trim(),
        comments:this.description

      }
      externalDisputeAction (input,this.myStr).then  (async result => {
        if(result.data.ReturnCode == 100){
          if(this.takeactionId=='29'){
            let input1 = {
              ShippingID : this.awbnumber,
              username : window.localStorage.getItem('username'),
              actionstatuscode : '30',
              reason:this.disputeReason.label.trim(),
              comments:this.description
      
            }
             await externalDisputeAction(input1,this.myStr)
          }
              this.uploadDisputeFiles();
              this.$alertify.success(result.data.ReturnMessage);
              this.$router.push({ path: '/InvestigationActionByOperations' });
          }else{
              this.$alertify.error(result.ReturnMessage);
          }
        
      });
    }
    },

    updatedata() {

      if (!this.takeactionId) {
        this.$alertify.error("Please Select Take Action.")
      } else if (!this.verifiedas && this.takeactionId !== 13) {
        this.$alertify.error("Please Select Verified As.")
      }  else if (this.verifiedas !== 'Physically' && this.imagesarr.length <= 2 && this.takeactionId !== 13) {
        this.$alertify.error("Please Upload Three images")
      }
      else if (this.declaredvalues >= 2000 && this.takeactionId == 20 && this.imagesarr.length == 0) {
        this.$alertify.error("Please Upload Three images")
      }
      else if(this.takeactionId == 14 && this.imagesarr.length == 0){
        this.$alertify.error("Images are required for marking shipment as damage");
      }
      else {
        let currentdate = moment(new Date()).format("DD-MM-YYYY HH:mm:ss");

        this.input = ({
          ShippingID: this.awbnumber,
          ActionStatusId: this.takeactionId.toString(),
          ShipmentVerifiedAs: this.verifiedas ? this.verifiedas : "-",
          CurrentHubID: this.currenthubidPop,
          StatusMarkedFrom: "web",
          Comments: this.description,
          LastModifiedBy: this.username,
          LastModifiedDate: currentdate,
          IsManualInScan: "true",
          bagCondition:this.bagCondition.label?this.bagCondition.label:' ',
          stdReason:this.STDreason.value,
          reason :this.lostReason?this.lostReason.label:' ' 

        });
        if (this.takeactionId == 20 || this.takeactionId == 13) {
          let useriptracking = new UserIPTracking();
          let userTrackingData = useriptracking.setMeta(this.actionName, this.awbnumber)
            .setRouteUrl('/InvestigationActionByOperations')
            .createObject();

          sendIPTrackingData(userTrackingData);
        }
        axios({
          method: 'post',
          url: apiUrl.api_url + 'ActionforInvestigation',
          data: this.input,
          headers: {
            'Authorization': 'Bearer ' + this.myStr
          }

        }).then(result => {
          if (result.data.code == 200) {

            setTimeout(async () => {
              if (this.takeactionId == 20) {
                await createRECManifest(this.awbnumber, this.myStr);
              }
              this.$alertify.success(result.data.message)
              this.$router.push({ path: '/InvestigationActionByOperations' });
            }, 500);

          }
          else {
            this.$alertify.error(result.data.message)
          }
        })
      }//else

    },
    fetchDisputeReasons(actionId){
      let input = {
        disputeRaisedType : "XB"
      }
      if(this.shipmentType) input.taskType = this.shipmentType;
      if(actionId == 29) input.serviceType = "accept";
      if(actionId == 33) input.serviceType = "reject";
      fetchExternalDisputeReasons(input, this.myStr).then(reasons => {
        let resonData = reasons.data.ReturnResult;
        this.disputeReasonList = resonData.map((reasons, i) => ({id: i, label: reasons.reason}));
      })
    },
    onSubmit: function (event) {
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.statuss == 20) {
            this.updateExternalDispute();
            return;
          }
          this.updatedata();
        }
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    },
    onFileChange(e) {
      this.attachment = e.target.files[0];
      this.FileSelected = this.attachment;
      this.FileSelected = null;

    },
    goSummeryPage(awb) {
      const accessKey = createShipmentSummaryAccess(awb);
      window.open(this.$router.resolve({
        path: '/summerPage',
        query: { awb: awb, accessKey: accessKey }
      }).href, '_blank');
    },

    changeBucketModel(){
      this.bucketList = [];
      this.changeBucket = true;
      let currentBucket = this.$route.query.bucket ? this.$route.query.bucket : 0;
      let buckets = JSON.parse(window.localStorage.getItem('bucketList'));
      Object.entries(buckets).forEach(([key, value]) => {
        if(![currentBucket,'4','6','1'].includes(key))
        this.bucketList.push({
          id: key,
          label: value
        });
      });

      
    },
    
    async changeBucketConfirm(){
      let input = {
        "shippingid": this.awbnumber,
        "bucketcode": this.newBucket.id,
        "lastmodifiedby": this.username,
        "comments": `Bucket Chnaged to ${this.newBucket.label}: ${this.bucketChangeComment}`
  
      }
      let {data} = await changeBucketOwner(input, this.myStr);
      if(data.ReturnCode == 100){
        this.$alertify.success(data.ReturnMessage);
        this.$router.push({ path: '/InvestigationActionByOperations' });
        this.changeBucket = false;
        return
      }
      this.$alertify.error(data.ReturnMessage ? data.ReturnMessage : 'Opration Failed');
    },

    uploadFile() {
      if (this.attachment == null) {
        this.$alertify.error("Please Choose Image ");

      }
      if (this.attachment.size > 614400) {
        this.$alertify.error("Please Upload Document Less Than 600KB");

      }
      else {
        if (this.imagesarr.length >= 3) {
          this.$alertify.error("Only Three Image Upload");
        }
        else {

          let status = 0
          if (this.statuss !== undefined) {
            if (this.statuss === null || this.statuss === undefined) {
              this.statuss = 0;
            }
            status = this.statuss;
          }
          if (this.attachment.type == "image/jpeg" ||
            this.attachment.type == "image/jpg" || this.attachment.type == "image/png" || this.attachment.type == "image/gif" || this.attachment.type == "") {
            var form = new FormData();
            form.append('file', this.attachment);
            form.append('shippingid', this.awbnumber);
            form.append('primaryKey', 123),
              form.append('status', this.statuss);
            var inputpayload = form;
            var UploadedImage = this.attachment.name


            axios({
              method: 'post',
              url: `${apiUrl.api_url}uploadimage`,
              data: inputpayload,
              headers: {
                'Content-Type': 'application/json',
              },
            }).then((result) => {
              this.imagesarr.push({ file: UploadedImage, imgPath: result.data.data });
              if (this.imagesarr.length > 0 && this.imagesarr.length <= 3) {
                this.displaytable = true;
              }
              if (result.data.errorCode == 0) {
                this.$alertify.success('Image uploaded successfully');
              }
            },

              (error) => {
                this.show = false;
                this.displaytable = false;
                console.error(error);
              });

            inputpayload = null;
            this.attachment = null;
            this.FileSelected = null;
          }

          else {
            this.$alertify.error("Please upload only Allowed file format");

          }
        }
      }
    },
    downloadImage(file) {
      this.Isvideo = ((file.attachment.type).toString().includes("video")) ? true : false;
      this.imgData = file.url;
      setTimeout(() => {
        const videoElement = this.$refs.videoPlayer;
        videoElement.src = file.url;
        videoElement.load();
      },2000);
      this.showModal = true;
    },

    getImages(){
      let input = {"shippingid": this.awbnumber}

      fetchClientImages(input,this.myStr).then(img=>{
       this.assetsClient = img.data.data;
     this.assetsClient[0].imageurl.forEach(obj => {
     this.assetsClientValue = Object.values(obj);
   });
    this.assetsClient[0].vediourl.forEach(obj => {
      Object.entries(obj).forEach(([objKey, vid]) => {
        if (vid && !isValidUrl(vid)) {
          let videoInput = {
            key: vid
          };
          getVideoUrl(videoInput, this.myStr).then(videoData => {
            obj[objKey] = videoData.data.data[0].url;
          });
        }
      });
    });

     this.assetsClientValue.forEach(img => {
      if(isValidUrl(img) == false && img !== null) {
        let input = {
          bucketName: this.statuss == 20 ? awsBucketName.awsDisputeBucketName : awsBucketName.awsBucketName,
          key: img
        };
       getImage(input,this.token).then(imagesData => {
              let finalImage = imagesData.data.ImageData
               this.clientImages.push({attachment:finalImage})                         
           });
         }
         else{
           this.clientImages.push({attachment:img})                         
         }
       });
   });
},
   async showMediaOfImage(url){
     this.imgData = url;
     this.showModal = true;
   },

    closeImage() {
      this.showModal = false;
    },

    deleteImage(i) {
      let fileName = this.imagesarr[i].file ? this.imagesarr[i].file : '';
      const currentdate = moment(new Date()).format("DD_MM_YYYY");
      // if (this.statuss == 17 || this.statuss == 13) {
      //   this.input = ({
      //     key: `${awsBucketName}/STD/${this.awbnumber}/${currentdate}_${fileName}`,
      //     file: fileName
      //   });
      // }
      // else {
      //   this.input = ({
      //     key: `${awsBucketName}/123${this.awbnumber}/${currentdate}_${fileName}`,
      //     file: fileName
      //   });
      // }
      this.input = ({
        key: `STD/${this.awbnumber}/${currentdate}_${fileName}`,
        file: fileName
      });

      axios({
        method: 'post',
        url: `${apiUrl.api_url}deleteimage`,
        data: this.input,
        headers: {
          'Content-Type': 'application/json',
        },
      }).then((result) => {
        console.log("Error: ", result);
        if (result.data.errorCode == 0) {
          if (i > -1) {
            this.imagesarr.splice(i, 1);
            this.$alertify.error(result.data.msg);
          }
        } else {
          console.error(result.data.data);
          this.$alertify.error(result.msg);
        }
      },
        (error) => {
          console.error(error);
        });
    },
    isGoogleDriveLink(url) {
      return url && url.includes("drive.google.com");
    },
    convertToEmbedUrl(url) {
      const match = url.match(/(?:drive\.google\.com\/file\/d\/|id=)([^\/?]+)/);
      return match ? `https://drive.google.com/file/d/${match[1]}/preview` : url;
    },
    isImage(url) {
      return /\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(url);
    },
    isVideo(url) {
      return /\.(mp4|webm|ogg|mov)$/i.test(url);
    },
    downloadVideo(url) {
      if (!url) return;
      let targetUrl = url;
      let fileName = this.extractFileName(url);
      if (this.isGoogleDriveLink(url)) {
        const fileId = this.extractGoogleDriveId(url);
        if (fileId) {
          targetUrl = `https://drive.google.com/uc?export=download&id=${fileId}`;
          fileName = 'video.mp4';
        } else {
          alert('Invalid Google Drive link');
          return;
        }
      }
      window.open(targetUrl, '_blank', 'noopener,noreferrer');
      this.triggerVideoDownload(targetUrl, fileName);
    },
    async triggerVideoDownload(url, fileName = 'video.mp4') {
      if (!url || typeof document === 'undefined') return;
      try {
        const response = await fetch(url, { mode: 'cors' });
        if (!response.ok) throw new Error('Failed to fetch video');
        const blob = await response.blob();
        const blobUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = blobUrl;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(blobUrl);
      } catch (error) {
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    },
    extractGoogleDriveId(url) {
      const match = url.match(/\/file\/d\/(.*?)\//);
      return match ? match[1] : null;
    },
    extractFileName(url) {
      return url.split('/').pop().split('?')[0] || 'video.avi';
    },
    getVideoLabel(key) {
      const map = {
        UnboxingVideoProof1: 'Shipment Unboxing',
        PackagingVideoProof1: 'Packaging Video'
      };
      return map[key] || key;
    },
  },
};



// WEBPACK FOOTER //
// ./src/views/components/Edit/Edit.component.js